import {
  Box,
  Flex,
  Heading,
  LinkAnchor,
  mdBumps,
  PrimaryButton,
  smBumps,
  Status,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Trans } from 'react-i18next'

import { CoverOption, Quote } from '../../../../domain'
import {
  tCovers,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useOptionalCoverModal } from '../../covers/useOptionalCoverModal'

export interface AddOnCardProps {
  coverOption: CoverOption
  loading?: boolean
  quote: Quote
  onAdd: () => void
}

const tKey = TKey(`components.add-on-card`)

export const AddOnCard: FunctionComponent<AddOnCardProps> = ({
  coverOption,
  loading,
  quote,
  onAdd,
}) => {
  const { t } = useWriskTranslation()

  const amount = coverOption.premium

  const handleLinkMoreClicked = useOptionalCoverModal(quote)

  return (
    <Flex
      alignItems='flex-start'
      flexDirection='column'
      mb={smBumps}
      p={mdBumps}
      variant='raised'
      width={1}
    >
      <Status mb={smBumps} variant='info' typoSize='xs'>
        {t(tKey('status'))}
      </Status>
      <Heading mb={smBumps} typoSize='md' variant='h3'>
        {t(tCovers(coverOption.coverGroup, 'name'))}
      </Heading>
      <Box mb={mdBumps} width={1}>
        <Typo mb={smBumps} whiteSpace='pre-line'>
          <Trans t={t} i18nKey={tCovers(coverOption.coverGroup, 'description')} />
        </Typo>
        <LinkAnchor
          variant='standalone'
          typoSize='sm'
          onClick={() => handleLinkMoreClicked(coverOption)}
        >
          {t(tKey('actions.learn-more'))}
        </LinkAnchor>
      </Box>

      <PrimaryButton data-testid='add-on-button' loading={loading} onClick={onAdd}>
        {t(tKey('actions.add'), { amount })}
      </PrimaryButton>
    </Flex>
  )
}
